const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const EditSeqOfEventsMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5SQJYBcC0swEcMHsAzDMANzADs1YA6FCAGzAGIAZAeQEEARAbQAYAuolAAHfLHQp8FESAAeiDADYaATmUAOAMyaATP36aArGoAs2swHYANCACeSgIyb+NY8r2arap3qdqesr8ZgC+oXaomNh4RCTkVLRgALaiaPbMPNwA+gCSACoAogCyAsJIIOKSaNKyFYoIGHrG2jTaxlY6-GpqVkGaGnaOCAZ6NHpevZ78Ttoa-MbhkRDoWLgExGSU1DQpaRkcPGVyVVIycg0Y1qrKavyW2i4zd8pDSnqt981WTtZ9nsoOktwCtous4ltErtUulmABVAByhz4QhOEjOdVAl38bmM-E8amMejMZi05k0b0aLmMNE0v20E082nuPSswKia1imwSOwo+DQAAI9rCsnkiqVURVTjVzvVnFZ3KSWlZlI9XEYrGZKaNxpMVQZZvNFhEQasYht4ttaHzBcKMgAlErsABqhTFJWOUvRMsxCkQypohl62gJekJxm1-DGEzuUc8v2s+nZoM5FshvP5QphBy4KPKYm9tQuiGsYzMo2UAX6gNsDiUbgWwX8mj+lm+2naybN4O5VpoNqz+3hSNznoL1SLcpGVlaZnMeOUlZ8Ib0lIw1NpTicfVMzQCxmsXbBXMtUIAxgALMBngDWAogAEM0A-mGPKoXZVj3gf1PpNMEfBMRdSUpcsaDnLxOhCKwrDxIETQ5c0IR5WhL2vO9H2fV8nHzd8J0-P0RmMGkFmZEwZ2CEIvFAsY5n4WCTD8AIZjZBCUyQ3soQfCAIAFdAUhobiVgoKA+LQFJmAAYUdTgindCVcOlScvypQwaGXQlLG6cw9BVSkrCjdSowMBl9F0MwnCPVNkL7ISxIEoSUBE+zkmYQpXQRfJsnYSTJLhR0EUkt1uFkt0AGVClYQpJKKPM0Xw31Lk1TRwOZPETG8JxTC1OsEAPMttE1e5ggCcttCsjjTx2Oz+OSQSeKc0TauYbhCjC6TcgABXyXJ2ARbJJIACU4BEAHFCjir0EuLRpbjUGhF26FsVUK8scuGZQfAW6w7iJQI8UPNjuxPdNaBq8S6sc5zms4AAxW7oti7JCk8goAE0BuGsaJrfJSCKSgxFU1Tb8V3XxKR0JxaRDYGWmIkljWWY60xQ+reNqtHGpc5h8ntTggrC7IRpydzclawK2s+kbxsm8cMRmjBNTMdwfgTEkO26bRKSmdQ+jmMxiJcNQWwqnsqrOniXMx66LsyAAhYm+uyR0AEU4Ta2Lfo-RKlABBaHmZfaOi3SkGWZiyWkXfRt0rEJRZO1HzochqZYkySOAirXpqnLw3C3cxYOua2dAhn86Q7Fx-meMIjuPFHbMljGwAAJ2T-Bk+YR1cber36anK4zDcHoJmJAIstmClcr8QGfgPCx0ruQr7fjrjE4umgz2TsAnzAbGIBkMA6AoUh8BvQfO+78SsAdq0MFqjAIDAZ8UAYXOfRmgZ1ErMMO0L-xZnWxAtx+dw6ScAEmwWZubNb9H24nnvsZTtPk5oUQGCfQh07qh+p9gGfEhzwugvJeD4V5r2UoRJovRAyAgGOWDQ-hNSUlmL8QMwstyVhbCSc+19OI7C7skfA5ApaEOIVjZq-cKCDyciPMeNAyHkGsvg2AQCUggOXqvSUdN15ThglDDUx9jD-l8AybUQQjLw2aIyUReDxYMJSMQ3uGNGEUNls-dOb8P5oC-snOqjCwDMPFmw5IHCwFcMUtrGaxF5rEnDKSWY-g1CUkrMzJw9F3HtGFr4EwcjToKKISQpOqd06Z0KNnCB-1ED-lxFuZkUZLC9F6PpD44xjBZW3soCw-M-GozPDIQgKA9ECgfAAIwfBQKh8tFYIkiTrWaEiZz3AWF4SinR9KqAMpqTo6TmSFW3Lkvs+SKCFOKWUipVTJIjSCqwImCsETcD6nUhm2T3AHiJOfQOfNtRZPAllEMWgkG2xjkjOON9qptwknCTqIU5Jy0KJwR09psj5HYAAaRess-O1w2jBFuH4SwMEPhcyrsEGk241DMn8GSSywI+SL3gBURCYtTrxTzipDA2DUoLCMMI2u5g1ztBpNYUktcPAdE8IjU0ZyWF0EYGANFvCVJzHUAmPwCDpjpLXP0Gg5dYIzm+DoQZUI7SMsgdiEIvL9CgxwXSUlKDZi8r+TMOGfg5rCozLabMYqonTgbJofQ6yVqmBaAqsYWha7lnoq4cssLTlGP8WhW894nwPh1fUtBlL2g4h6a4QIhL5oDB+HSdJWgiRGGUBqiWd8UjuoZj4VQFgcUZXxYfBAFh5paC0kEIIgLehRrRlLK6TULpxvzhMVokKDBZJVLcOYnhKREgVIYVUvSPC9CFbHB1jtLl1Q0cnMtGKPi2NuDMBkCwsrYJQRZZmvgPAGvxGtO2XbKr+Kdj-Luj9aqDqgZYZm3gdA6R+Ak1cVdtytBaBYc9dJiSkgLQYlyO6GjpKhnY+GlYGRCwjLlOYUMNBNvcYXMw-5I0rpRajB9KjFGkDUbGqa6LCJgt+S0EwCwWz-tAltLw1teis3Ppoe90HlHt37U+xAm0oZ9B6HAlsOJnG5VuClPEWV9o-CyeWAtwzRnJBKeUypBE-r1JUGg-li46I+ANNqXQC1pXpI6ES4k5VwihCAA */
    predictableActionArguments: true,

    id: "edit-seq-of-events",

    context: {
      qmsToolApiUrl: undefined,
      sequence_of_events_items_details: [],
      authentication: {
        token: undefined,
      },
    },

    states: {
      idle: {
        on: {
          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },
        },
      },

      empty: {
        on: {
          ADD_ITEM: {
            target: "add item.adding item",
            actions: "setInitialOccurenceDate",
          },

          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },

          UNLOAD: {
            target: "idle",
            actions: "resetLoadRequest",
          },
        },
      },

      "not empty": {
        on: {
          ADD_ITEM: {
            target: "add item.adding item",
            actions: "setInitialOccurenceDate",
          },

          REMOVE_ITEM: {
            target: "remove item",
            actions: "saveRemoveRequestItem",
          },

          LOAD: {
            target: "check data",
            actions: "saveLoadRequest",
          },

          UNLOAD: {
            target: "idle",
            actions: "resetLoadRequest",
          },
        },
      },

      "check data": {
        always: [
          {
            target: "empty",
            cond: "seqOfEventsEmpty",
          },
          "not empty",
        ],
      },

      "add item": {
        initial: "adding item",

        states: {
          "adding item": {
            on: {
              CREATE_ITEM: {
                target: "create item",
                cond: "validChangeSet",
              },

              EVENT_OCCURENCE_DATE_SELECTED: {
                target: "adding item",
                internal: true,
                actions: "saveEventOccurenceDate",
              },

              DESCRIPTION_CHANGED: {
                target: "adding item",
                internal: true,
                actions: "saveDescription",
              },

              AFFECTED_ENTITY_CHANGED: {
                target: "adding item",
                internal: true,
                actions: "saveAffectedEntity",
              },

              TRACES_AND_EVIDENCES_CHANGED: {
                target: "adding item",
                internal: true,
                actions: "saveTracesAndEvidences",
              },

              ABANDON_REQUESTED: "#edit-seq-of-events.confirm abandon",
              CLOSE: {
                target: "#edit-seq-of-events.check data",
                actions: "unflagChanges",
              },
            },
          },

          error: {
            on: {
              RETRY: "create item",
            },

            entry: "saveError",
          },

          "create item": {
            invoke: {
              src: "createSeqOfEventsItemDetail",
              id: "create-sq-of-events-item-detail",

              onDone: {
                target: "adding item",
                actions: [
                  "saveReturnedItemsDetails",
                  "resetChangeSet",
                  "setInitialOccurenceDate",
                  "flagChanges",
                ],
              },

              onError: "error",
            },
          },
        },

        on: {
          UPDATE_BEARER_TOKEN: {
            target: "add item",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },
        },
      },

      "remove item": {
        states: {
          "removing item": {
            invoke: {
              src: "removeSeqOfEventsItemDetail",
              id: "remove-seq-of-events-item-detail",

              onDone: {
                target: "#edit-seq-of-events.check data",
                actions: "resetRemoveItemRequest",
              },

              onError: "error",
            },
          },
          error: {
            entry: "saveError",

            on: {
              RETRY: "removing item",
            },
          },
        },

        initial: "removing item",
      },

      "confirm abandon": {
        on: {
          ABANDON: {
            target: "check data",
            actions: ["resetAddItemRequest", "resetChangeSet"],
          },
          CANCEL_ABANDON: "add item.adding item",
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { EditSeqOfEventsMachine };
